import React, { Component } from 'react';
import { Col, Table } from 'react-bootstrap';
import R6SLogo from './media/r6s-logo.png';
import Product from './Product';

export default class Calculator extends Component {
    state = {
        inputADS: 36,
        ratio: "16/9",
        fov: 90,
        multi: localStorage.getItem('multi') ? localStorage.getItem('multi') : 0.02,
        x1: null,
        x15: null,
        x20: null,
        x25: null,
        x30: null,
        x40: null,
        x50: null,
        x120: null
    }
    componentDidMount(){
        this.calculateSens();
    }
    async handleChangeADS(event) {
        await this.setState({inputADS: event.target.value});
        localStorage.setItem('ads', this.state.inputADS);
        this.calculateSens();
    }
    async handleChangeRatio(event) {
        await this.setState({ratio: event.target.value});
        localStorage.setItem('ratio', this.state.ratio);
        this.calculateSens();
    }
    async handleChangeFov(event) {
        await this.setState({fov: event.target.value});
        localStorage.setItem('fov', this.state.fov);
        this.calculateSens();
    }
    async handleChangeMulti(event) {
        await this.setState({multi: event.target.value});
        localStorage.setItem('multi', this.state.multi);
        this.calculateSens();
    }
    calculateSens(){
        const input = localStorage.getItem('ads') ? localStorage.getItem('ads') : this.state.inputADS;
        let fov = localStorage.getItem('fov') ? localStorage.getItem('fov') * (Math.PI/180) : this.state.fov * (Math.PI/180);
        let ratioArray = localStorage.getItem('ratio') ? localStorage.getItem('ratio').split('/') : this.state.ratio.split('/');
        let ratio = (+ratioArray[0])/(+ratioArray[1]);
        let hFov = 2*Math.atan(Math.tan(fov/2)*ratio);
        let fovFinal = hFov > 2.61798 ? 2*Math.atan(Math.tan(1.309)/ratio) : fov;
        let x1, x15, x20, x25, x30, x40, x50, x120;
        
        // 1X Scope
        let fovmult = 0.9
		let adsmult = 0.6
		let fovadj = Math.tan(fovmult*fovFinal/2)/Math.tan(fovFinal/2)
        x1 = Math.round((adsmult/fovadj)*input);

        // 1.5X Scope
        fovmult = 0.59
		adsmult = 0.59
		fovadj = Math.tan(fovmult*fovFinal/2)/Math.tan(fovFinal/2)
        x15 = Math.round((adsmult/fovadj)*input);

        // 2X Scope
        fovmult = 0.49
		adsmult = 0.49
		fovadj = Math.tan(fovmult*fovFinal/2)/Math.tan(fovFinal/2)
        x20 = Math.round((adsmult/fovadj)*input);

        // 2.5X Scope
        fovmult = 0.42
		adsmult = 0.42
		fovadj = Math.tan(fovmult*fovFinal/2)/Math.tan(fovFinal/2)
        x25 = Math.round((adsmult/fovadj)*input);

        // 3X Scope
        fovmult = 0.35
		adsmult = 0.35
		fovadj = Math.tan(fovmult*fovFinal/2)/Math.tan(fovFinal/2)
        x30 = Math.round((adsmult/fovadj)*input);

        // 4X Scope
        fovmult = 0.3
		adsmult = 0.3
		fovadj = Math.tan(fovmult*fovFinal/2)/Math.tan(fovFinal/2)
        x40 = Math.round((adsmult/fovadj)*input);

        // 5X Scope
        fovmult = 0.22
		adsmult = 0.22
		fovadj = Math.tan(fovmult*fovFinal/2)/Math.tan(fovFinal/2)
        x50 = Math.round((adsmult/fovadj)*input);

        // 12X Scope
        fovmult = 0.092
		adsmult = 0.14
		fovadj = Math.tan(fovmult*fovFinal/2)/Math.tan(fovFinal/2)
        x120 = Math.round((adsmult/fovadj)*input);

        this.setState({x1: x1, x15: x15, x20: x20, x25: x25, x30: x30, x40: x40, x50: x50, x120: x120});
    }
    render() {
        return (
            <React.Fragment>
                <div className="logo">
                    <img src={R6SLogo} alt="R6S Logo"/>
                    <h1>SHADOW LEGACY ADS CALCULATOR</h1>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-md-7">
                            <div className="calculator-wrapper">
                                <div className="calc-input">
                                    <h3>Your Current ADS Sensitivity</h3>
                                    <input className="ads-input" defaultValue={localStorage.getItem('ads') ? localStorage.getItem('ads') : this.state.inputADS} type="number" onChange={this.handleChangeADS.bind(this)} />
                                </div>
                                <div className="calc-input">
                                    <h3>Aspect Ratio</h3>
                                    <select className="ads-select" onChange={this.handleChangeRatio.bind(this)} defaultValue={localStorage.getItem('ratio') ? localStorage.getItem('ratio') : this.state.ratio}>
                                        <option value="16/9">16:9 (Auto)</option>
                                        <option value="16/10">16:10</option>
                                        <option value="4/3">4:3</option>
                                        <option value="3/2">3:2</option>
                                        <option value="5/3">5:3</option>
                                        <option value="5/4">5:4</option>
                                        <option value="19/10">19:10</option>
                                        <option value="21/9">21:9</option>
                                    </select>
                                </div>
                                <div className="calc-input">
                                    <h3>FOV</h3>
                                    <input className="ads-input" defaultValue={localStorage.getItem('fov') ? localStorage.getItem('fov') : this.state.fov} type="number" placeholder="90" onChange={this.handleChangeFov.bind(this)} />
                                </div>
                                <div className="calc-input">
                                    <h3>Multiplier</h3>
                                    <input className="ads-input" defaultValue={localStorage.getItem('multi') ? localStorage.getItem('multi') : this.state.multi} type="number" placeholder="90" onChange={this.handleChangeMulti.bind(this)} />
                                </div>
                                <div className="calc-table">
                                <h5 style={{fontWeight: '400', marginBottom: '15px', letterSpacing: '1px', textTransform: 'uppercase', textAlign: 'center'}}>Calculated Sensitivity:</h5>
                                <Table striped bordered>
                                    <thead>
                                    <tr>
                                        <th>Scope</th>
                                        <th>Sensitivity</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>1.0X</td>
                                        <td>{Math.round(this.state.x1 / (this.state.multi * 100 / 2))}</td>
                                    </tr>
                                    <tr>
                                        <td>1.5X</td>
                                        <td>{Math.round(this.state.x15 / (this.state.multi * 100 / 2))}</td>
                                    </tr>
                                    <tr>
                                        <td>2.0X</td>
                                        <td>{Math.round(this.state.x20 / (this.state.multi * 100 / 2))}</td>
                                    </tr>
                                    <tr>
                                        <td>2.5X <small>(ACOG)</small></td>
                                        <td>{Math.round(this.state.x25 / (this.state.multi * 100 / 2))}</td>
                                    </tr>
                                    <tr>
                                        <td>3.0X</td>
                                        <td>{Math.round(this.state.x30 / (this.state.multi * 100 / 2))}</td>
                                    </tr>
                                    <tr>
                                        <td>4.0X</td>
                                        <td>{Math.round(this.state.x40 / (this.state.multi * 100 / 2))}</td>
                                    </tr>
                                    <tr>
                                        <td>5.0X</td>
                                        <td>{Math.round(this.state.x50 / (this.state.multi * 100 / 2))}</td>
                                    </tr>
                                    <tr>
                                        <td>12.0X</td>
                                        <td>{Math.round(this.state.x120 / (this.state.multi * 100 / 2))}</td>
                                    </tr>
                                    </tbody>
                                </Table>
                                <p style={{textAlign: 'center'}}>Note: ADS Calculator is now updated according to Ubisoft's official calculation values.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="suggestion-wrapper">
                                <h3>Suggested Mouse For Best Sensitivity</h3>
                                <Product 
                                    name="Logitech G Pro X Superlight"
                                    description="A very lightweight mouse with precise sensor along with the fastest wireless connectivity gives you the best Siege experience."
                                    image="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B087LXCTFJ&Format=SL160&ID=AsinImage&MarketPlace=US&ServiceVersion=20070822&WS=1&tag=ridoyrajoan-20&language=en_US"
                                    link="https://amzn.to/2X6WGuK"
                                />
                                <Product 
                                    name="Razer Viper Ultimate"
                                    description="The alternative choice for G Pro. Its as good as the G Pro and more faster response with the optical switch and very lightweight."
                                    image="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B07YPC3BQC&Format=SL160&ID=AsinImage&MarketPlace=US&ServiceVersion=20070822&WS=1&tag=ridoyrajoan-20&language=en_US"
                                    link="https://amzn.to/3nmbtfM"
                                />
                                <Product 
                                    name="Logitech G502 Wireless"
                                    description="A bit heavy but perfect for players with high sensitivity and flicks are never been so easier with the wireless technology."
                                    image="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B07L4BM851&Format=SL160&ID=AsinImage&MarketPlace=US&ServiceVersion=20070822&WS=1&tag=ridoyrajoan-20&language=en_US"
                                    link="https://amzn.to/3z1BNOr"
                                />
                                <Product 
                                    name="Glorious Model O"
                                    description="One of the best lightweight mouse with honeycomb design. Best suited for low sensitivity players."
                                    image="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B07MGDRBBF&Format=SL160&ID=AsinImage&MarketPlace=US&ServiceVersion=20070822&WS=1&tag=ridoyrajoan-20&language=en_US"
                                    link="https://amzn.to/3hhq6x6"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-credit">
                    <Col>
                    <p>Made By: <a href="https://facebook.com/nxtabid">Abid</a>. Credits to <a href="https://twitter.com/kurtextrem">KurtXTRM</a></p>
                    </Col>
                </div>
            </React.Fragment>
        )
    }
}
